import * as types from '../mutation-types';
import {
  getBidderDissentState,
  getBidderDissentCount,
  getDissentBidSectionReply,
} from '@/api/objection';
import { checkSendMsg } from '@/api/common';
import { Message } from 'element-gui';
const state = {
  socketObj: [], // 在线离线
  socketType: {}, // 开标结束
  socketMsg: {}, // 互动咨询系统消息
  companyList: [], // 異議投標單位列表
  companyItem: {}, // 异议列表选中条目
  isDissent: {}, // 异议权限
  isDissentCount: {}, // 异议数量
  setAllGreeObj: {}, // 所有投標人都没有异议状态
  setBidderList: {}, // 异议左侧标识
  setRoomList: {}, // 异议右侧标识
  isDissentNum: false, // 没有异议数量
  endDissent: false, // 是否結束意義
  endDissentAll: { visible: false }, // 是否全部標段結束意義
  dissentInitObj: {
    // 异议初始化
    start: false,
    dissentTime: 0,
  },
  dissentTimeObj: {
    // 异议倒计时结束
    end: false,
  },
  extractObj: {}, // 抽取提示
  readBidObj: {}, // 招标控制价修改，更新唱标数据
  pubResultObj: {
    // 开始第二信封开标提示
    out: false,
  },
  //计算并宣布评标基准价 自动算分-消息推送
  calBasePriceFinishObj: {
    finish: false,
    msgCode: '',
  },
  //计算并宣布评标基准价 手动算分-消息推送
  calBasePriceConfirmObj: {
    finish: false,
    msgCode: '',
    state: 2,
  },
  dissentMessage: {}, // 未读消息数量
  isCanSendMsg: {}, //互动咨询-系统公告 是否可以发消息
  dissentRedRoll: [], // 异议消息体数组
  allRoom: {}, // 全局异议已读未读数量
  allDissentRight: {
    domainId: '',
    stage: 0,
  },
  socketParams: {}, // 多页签交互存储
};

const getters = {
  getAllDissentRight: (state) => state.allDissentRight,
  getCompanyList: (state) => state.companyList,
  getCompanyItem: (state) => state.companyItem,
  getSocketObj: (state) => state.socketObj,
  getSocketState: (state) => state.socketType,
  getSocketMsgList: (state) => state.socketMsg,
  getDissent: (state) => state.isDissent,
  getDissentCountObj: (state) => state.isDissentCount,
  getAllGreeObj: (state) => state.setAllGreeObj,
  getBidderList: (state) => state.setBidderList,
  getRoomList: (state) => state.setRoomList,
  getAllRoom: (state) => state.allRoom,
  getDissentNum: (state) => state.isDissentNum,
  getInitObj: (state) => state.dissentInitObj,
  getTimeObj: (state) => state.dissentTimeObj,
  getExtractObj: (state) => state.extractObj,
  getReadBidObj: (state) => state.readBidObj,
  getPubResultObj: (state) => state.pubResultObj,
  getBasePriceFinishObj: (state) => state.calBasePriceFinishObj,
  getBasePriceConfirmObj: (state) => state.calBasePriceConfirmObj,
  getIsCanSendMsg: (state) => state.isCanSendMsg,
  getEndDissent: (state) => state.endDissent,
  getEndDissentAll: (state) => state.endDissentAll,
  getDissentMessage: (state) => state.dissentMessage,
  getDissentRedRoll: (state) => state.dissentRedRoll,
};

const actions = {
  async sendMsgToSocket({ commit }, obj) {
    commit(types.GET_SOCKET_PARAMS, obj);
  },
  async setAllDissentRight({ commit }, obj) {
    commit(types.GET_AllDISSENTRIGHT_STATUS, obj);
  },
  async setCompanyList({ commit }, obj) {
    commit(types.GET_COMPANYLIST_STATUS, obj);
  },
  async setEndDissent({ commit }, obj) {
    commit(types.GET_ENDDISSENT_STATUS, obj);
  },
  async setEndDissentAll({ commit }, obj) {
    commit(types.GET_ENDDISSENTALL_STATUS, obj);
  },
  async setCompanyItem({ commit }, obj) {
    commit(types.GET_COMPANYITEM_STATUS, obj);
  },
  async getSocketKeys({ commit }, obj) {
    commit(types.GET_SOCKET_STATUS, obj);
  },
  async getSocketType({ commit }, obj) {
    commit(types.GET_SOCKET_TYPE, obj);
  },
  async getSocketMsg({ commit }, obj) {
    commit(types.GET_SOCKET_MSG, obj);
  },
  async getAllAgree({ commit }, obj) {
    commit(types.GET_DISSENT_AGREE, obj);
  },
  async getBidderListRefresh({ commit }, obj) {
    commit(types.GET_DISSENT_LIST, obj);
  },
  async getChatRoomRefresh({ commit }, obj) {
    commit(types.GET_DISSENT_ROOM, obj);
  },
  async getAllRoomRefresh({ commit }, obj) {
    commit(types.GET_ALL_ROOM, obj);
  },
  async getBidderDissentCount({ commit }, obj) {
    commit(types.GET_DISSENT_NUM, obj);
  },
  // 异议初始化
  async initDissent({ commit }, obj) {
    commit(types.GET_DISSENT_INIT, obj);
  },
  // 异议倒计时时间到
  async endTimeDissent({ commit }, obj) {
    commit(types.GET_DISSENT_TIME, obj);
  },
  // 异议已读未读
  async setDissentMessage({ commit }, obj) {
    commit(types.GET_DISSENT_MESSAGE, obj);
  },
  // 系数抽取
  async paramExtract({ commit }, obj) {
    commit(types.GET_PARAM_EXTRACT, obj);
  },
  //更新唱标数据
  async refreshReadBidData({ commit }, obj) {
    commit(types.GET_READ_BID, obj);
  },
  // 公布第一信封评审结果
  async pubResult({ commit }, obj) {
    commit(types.GET_PUB_RESULT, obj);
  },
  // 评标基准价-自动算分-计算成功状态
  async openBidBasePriceFinish({ commit }, obj) {
    commit(types.CAL_BASEPRICE_FINISH, obj);
  },
  // 评标基准价-手动算分-确认状态
  async openBidBasePriceConfirm({ commit }, obj) {
    commit(types.CAL_BASEPRICE_CONFIRM, obj);
  },
  //判断右侧：是否可以发消息
  async checkSendMsg({ commit }, id) {
    await checkSendMsg({
      domainId: id,
    }).then((res) => {
      commit(types.GET_CHECK_SEND_MSG, res.data);
    });
  },
  // 意義推送消息數量
  async getDissentBidSectionReply({ commit }, obj) {
    await getDissentBidSectionReply({
      openbidIds: obj.openbidIds,
      bidderName: obj.bidderName,
    }).then((res) => {
      if (res.code == 200) {
        commit('GET_DISSENTRED_ROLL', res.data);
      } else {
        Message({
          message: res.msg,
          type: 'error',
        });
      }
    });
  },
  // 异议权限
  async getDissentMsg({ commit }, obj) {
    await getBidderDissentState({
      openbidId: obj.openbidId,
      bidSectionId: obj.bidSectionId,
      projectId: obj.projectId,
      domainId: obj.domainId,
      bidderId: obj.bidderId,
    }).then((res) => {
      if (res.code == 200) {
        commit('GET_DISSENT_MSG', res.data);
      } else {
        Message({
          message: res.msg,
          type: 'error',
        });
      }
    });
  },
  // 异议数量
  async getDissentCount({ commit }, obj) {
    // 获取不同状态下的投标单位数量
    await getBidderDissentCount({
      openbidId: obj.openbidId,
      projectId: obj.projectId,
      bidSectionId: obj.bidSectionId,
      domainId: obj.domainId,
    }).then((res) => {
      if (res.code == 200) {
        commit('GET_DISSENT_COUNT', res.data);
      } else {
        Message({
          message: res.msg,
          type: 'error',
        });
      }
    });
  },
};

const mutations = {
  [types.GET_AllDISSENTRIGHT_STATUS](state, obj) {
    state.allDissentRight = obj;
  },
  [types.GET_SOCKET_STATUS](state, obj) {
    state.socketObj = obj;
  },
  [types.GET_SOCKET_TYPE](state, obj) {
    state.socketType = obj;
  },
  [types.GET_SOCKET_MSG](state, obj) {
    state.socketMsg = obj;
  },
  [types.GET_DISSENT_MSG](state, obj) {
    state.isDissent = obj;
  },
  [types.GET_CHECK_SEND_MSG](state, obj) {
    state.isCanSendMsg = obj;
  },
  [types.GET_DISSENT_COUNT](state, obj) {
    state.isDissentCount = obj;
  },
  [types.GET_DISSENTRED_ROLL](state, obj) {
    state.dissentRedRoll = obj;
  },
  [types.GET_DISSENT_AGREE](state, obj) {
    state.setAllGreeObj = obj;
  },
  [types.GET_DISSENT_LIST](state, obj) {
    state.setBidderList = obj;
  },
  [types.GET_DISSENT_ROOM](state, obj) {
    state.setRoomList = obj;
  },
  [types.GET_DISSENT_NUM](state, obj) {
    state.isDissentNum = obj;
  },
  [types.GET_DISSENT_INIT](state, obj) {
    state.dissentInitObj = obj;
  },
  [types.GET_DISSENT_TIME](state, obj) {
    state.dissentTimeObj = obj;
  },
  [types.GET_PARAM_EXTRACT](state, obj) {
    state.extractObj = obj;
  },
  [types.GET_READ_BID](state, obj) {
    state.readBidObj = obj;
  },
  [types.GET_PUB_RESULT](state, obj) {
    state.pubResultObj = obj;
  },
  [types.CAL_BASEPRICE_FINISH](state, obj) {
    state.calBasePriceFinishObj = obj;
  },
  [types.CAL_BASEPRICE_CONFIRM](state, obj) {
    state.calBasePriceConfirmObj = obj;
  },
  [types.GET_COMPANYLIST_STATUS](state, obj) {
    state.companyList = obj;
  },
  [types.GET_COMPANYITEM_STATUS](state, obj) {
    state.companyItem = obj;
  },
  [types.GET_ENDDISSENT_STATUS](state, obj) {
    state.endDissent = obj;
  },
  [types.GET_ENDDISSENTALL_STATUS](state, obj) {
    state.endDissentAll = obj;
  },
  [types.GET_DISSENT_MESSAGE](state, obj) {
    state.dissentMessage = obj;
  },
  [types.GET_ALL_ROOM](state, obj) {
    state.allRoom = obj;
  },
  [types.GET_SOCKET_PARAMS](state, obj) {
    state.socketParams = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
